import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PreviousProviderSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PreviousProviderSVG;
